"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var react_1 = __importDefault(require("react"));
var redux_1 = require("redux");
var Table_1 = __importDefault(require("atomicComponents/atoms/Table/Table"));
var TableBody_1 = __importDefault(require("atomicComponents/atoms/Table/TableBody"));
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var hooks_1 = require("atomicComponents/organisms/SortableHeader/hooks");
var SortHoC_1 = __importDefault(require("atomicComponents/organisms/SortableHeader/SortHoC"));
var ScrollDiv_1 = __importDefault(require("components/Layout/ScrollDiv"));
var ServiceCell_1 = __importDefault(require("containers/MyStack/styles/ServiceCell"));
var Heading_1 = __importDefault(require("shared/components/Heading"));
var eventHandlers_1 = require("utils/form/eventHandlers");
var parser_1 = require("utils/form/parser");
var HoCs_1 = require("utils/HoCs");
var hooks_2 = require("utils/hooks");
var hooks_3 = require("./hooks");
var ServicesListRow_1 = __importDefault(require("./ServicesListRow"));
var ServicesTableFooter_1 = __importDefault(require("./ServicesTableFooter"));
var ServicesTableHeader_1 = __importDefault(require("./ServicesTableHeader"));
var TeamPreviewContainer_1 = __importDefault(require("./styles/TeamPreviewContainer"));
var TeamsPreviewInput_1 = __importDefault(require("./styles/TeamsPreviewInput"));
var TeamPreviewHeader_1 = __importDefault(require("./TeamPreviewHeader"));
var TeamPreview = function (_a) {
    var onClickClose = _a.onClickClose, team = _a.team;
    var _b = __read(react_1.default.useState((team === null || team === void 0 ? void 0 : team.headcount) || 0), 2), headcount = _b[0], setHeadcount = _b[1];
    var _c = __read((0, hooks_2.useSubmitter)('company_teams', team.id), 2), teamSubmitter = _c[0], isSubmitting = _c[1];
    var getTeamStats = (0, hooks_3.useGetToolCountAndSpend)();
    var _d = getTeamStats(team), spend = _d.spend, serviceStats = _d.serviceStats;
    var sortedServiceStatsWithExtras = (0, hooks_1.useSortArray)(getTeamStats(team).serviceStats, {
        serviceName: function (sS) { var _a, _b; return ((_a = sS.service) === null || _a === void 0 ? void 0 : _a.niceName) || ((_b = sS.service) === null || _b === void 0 ? void 0 : _b.name); },
    });
    react_1.default.useEffect(function () {
        if (team.headcount !== headcount)
            setHeadcount(team.headcount);
    }, [team.headcount]);
    var handleClose = function () { return teamSubmitter({ headcount: headcount }); };
    return ((0, jsx_runtime_1.jsx)(TeamPreviewContainer_1.default, { children: (0, jsx_runtime_1.jsx)(ScrollDiv_1.default, { children: (0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ width: 1000, height: "100%", mb: 4, px: 4 }, { children: [(0, jsx_runtime_1.jsx)(Box_1.default, __assign({ mt: 0.5, display: "flex", justifyContent: "flex-end" }, { children: (0, jsx_runtime_1.jsx)(IconButtons_1.CloseButton, { onClick: onClickClose }) })), (0, jsx_runtime_1.jsx)(TeamPreviewHeader_1.default, { team: team, spend: spend, toolsCount: serviceStats.length }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: "Headcount" })), (0, jsx_runtime_1.jsx)(TeamsPreviewInput_1.default, { type: "text", onChange: function (e) { return setHeadcount((0, parser_1.parseNumber)(e.target.value)); }, onBlur: handleClose, onKeyPress: (0, eventHandlers_1.onHitEnter)(handleClose), disabled: isSubmitting, variant: 'standard', name: "headcount", value: headcount, InputProps: { disableUnderline: true, inputProps: { style: { textAlign: 'center' } } } }), (0, jsx_runtime_1.jsx)(Heading_1.default, __assign({ level: 2 }, { children: "Tools" })), (0, jsx_runtime_1.jsxs)(Table_1.default, __assign({ maxWidth: 1000, pl: 2, pr: 4, ml: -2 }, { children: [(0, jsx_runtime_1.jsx)(ServicesTableHeader_1.default, { toolsCount: serviceStats.length }), (0, jsx_runtime_1.jsxs)(TableBody_1.default, __assign({ ml: -2 }, { children: [sortedServiceStatsWithExtras === null || sortedServiceStatsWithExtras === void 0 ? void 0 : sortedServiceStatsWithExtras.map(function (stat) { return ((0, jsx_runtime_1.jsx)(ServicesListRow_1.default, { item: stat, team: team }, stat.id)); }), !serviceStats.length && (0, jsx_runtime_1.jsx)(ServiceCell_1.default, __assign({ textAlign: "center" }, { children: "No tools found" }))] })), (0, jsx_runtime_1.jsx)(ServicesTableFooter_1.default, { toolsCount: serviceStats.length, totalSpend: spend })] }))] })) }) }));
};
exports.default = (0, redux_1.compose)(HoCs_1.HasCompanyHoC, react_1.default.memo, function (Component) { return (0, SortHoC_1.default)(Component, { key: 'serviceName', order: 1 }); })(TeamPreview);
